import { StableChildren } from '@prophecy/utils/react/StableChildren';
import { createContext, useContext } from 'react';

export const StateUpdateContext = createContext<boolean>(true);

export function StateUpdateEnabledProvider({
  children,
  enabled = true
}: {
  children: React.ReactNode;
  enabled: boolean;
}) {
  return (
    <StateUpdateContext.Provider value={enabled}>
      <StableChildren>{children}</StableChildren>
    </StateUpdateContext.Provider>
  );
}

export function useStateUpdateEnabled() {
  return useContext(StateUpdateContext);
}
